<template>
    <v-container class="py-7">
        <v-row>
            <v-col :cols="12">
                <div class="title-container">
                    <div class="title-block">
                        <span id="title" class="page-title">Relatórios</span>
                        <v-breadcrumbs class="app-breadcrumb" divider="›" :items="[
                            {
                                text: 'Homepage',
                                disabled: false,
                                to: '/home',
                                exact: true,
                            },
                            {
                                text: 'Relatórios',
                                disabled: true,
                                exact: true,
                            },
                        ]"></v-breadcrumbs>
                    </div>
                </div>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12">
                <v-card class="table-card">
                    <v-card-title class="filter-card-title">Filtros</v-card-title>
                    <v-form @submit.prevent="load()">
                        <v-divider class="mt-2"></v-divider>

                        <v-container>
                            <v-row class="mt-3">
                                <v-col cols="8" align-self="baseline">
                                    <v-text-field style="padding-left: 6px;" dense
                                        label="Pesquisar por identificador e CPF/CNPJ" v-model="dataList.filter.content"
                                        no-data-text="Nenhuma informação disponível" hide-details outlined clearable
                                        @click:clear="clearNameSearch">
                                    </v-text-field>
                                </v-col>

                                <v-spacer></v-spacer>

                                <v-col v-if="hasFilters()" cols="auto" style="padding-right: 1px;">
                                    <v-tooltip bottom>
                                        <template #activator="{ on }">
                                            <v-btn v-on="on" id="btnClearFilter" type="button" outlined color="primary"
                                                @click="clearFilters">
                                                Limpar</v-btn>
                                        </template>
                                        <span>Limpar filtros de busca selecionados</span>
                                    </v-tooltip>
                                </v-col>

                                <v-col cols="auto" style="padding-right: 16px;">
                                    <v-btn id="btnFilter" type="submit" color="primary" dark
                                        elevation="2">Filtrar</v-btn>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-form>

                    <v-card-title class="table-card-title">Relatórios</v-card-title>
                    <v-card-text>
                        <v-data-table :headers="dataList.headers" :items="dataList.data" :disable-sort="true"
                            :loading="dataList.loading"
                            :no-data-text="dataList.filter.content ? 'Nenhum relatório foi encontrado' : 'Utilize a filtragem para trazer as informações'"
                            disable-pagination hide-default-footer loading-text="Carregando dados..."
                            class="app-table hover-table">
                            <template v-slot:[`item.association`]="{ item }">
                                <span class="list-item-title">{{ item.association }}</span><br />
                            </template>

                            <template v-slot:[`item.creditor`]="{ item }">
                                <span class="list-item-title text-uppercase">{{ item.value_type_2 || 'N/A'
                                    }}</span><br />
                                <span class="caption mediumGray--text"><strong>CPF/CNPJ</strong>: {{
                                    item.value_type_3 ? formatCpfCnpj(item.value_type_3) : 'N/A' }}</span>
                            </template>

                            <template v-slot:[`item.created_at`]="{ item }">
                                {{ item.created_at | defaultDate("DD/MM/YYYY HH:mm:ss") }}
                            </template>

                            <template v-slot:[`item.actions`]="{ item }">
                                <v-icon :disabled="!$check(user, ['reports.find'])" @click="viewItem(item)" size="large"
                                    class="me-2">
                                    mdi-eye-outline
                                </v-icon>
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>

import Vue from "vue";
import VueLodash from 'vue-lodash'
import _ from 'lodash';
import axios from 'axios';

import { cpf, cnpj } from 'cpf-cnpj-validator'

import object from "@/common/util/object"
import status from "@/common/data/user-status.data";

// import CardItemA from "@/layouts/components/CardItemA";

Vue.use(VueLodash)

export default {
    name: "ReportList",

    // components: {
    //     CardItemA,
    // },

    data: () => ({
        user: null,
        dataset: {
            data: {}
        },
        dataList: {
            filter: {
                content: "",
            },
            headers: [
                { text: "Identificador", value: "association" },
                { text: "Credor", value: "creditor" },
                { text: "Modelo", value: "type.name" },
                { text: "Arquivo", value: "file.name" },
                { text: 'Ações', value: 'actions', sortable: false },
            ],
            data: [],
            loading: false,
            count: 0,
        },
    }),

    created() {
        this.load();
    },

    methods: {
        goBack() {
            this.$router.replace("/relatorio");
        },

        hasFilters() {
            return Object.values(this.dataList.filter).some(value => value !== "");
        },

        clearFilters() {
            Object.keys(this.dataList.filter).forEach(key => {
                this.dataList.filter[key] = "";
            });
            this.load();
        },

        clearNameSearch() {
            this.dataList.filter.content = "";
            this.load();
        },

        debounce: _.debounce(function () {
            this.reload();
        }, 500),

        reload: function () {
            this.load();
        },

        async load() {
            this.user = this.$root.user.data || this.$root.user;

            let search = Object.fromEntries(Object.entries(this.dataList.filter).filter(([_, v]) => v))

            search = !object.isEmpty(search) ? search : null;

            this.dataList.loading = true;

            try {
                const result = await axios.get('/api/admin/reports', { params: { search: search } });

                this.dataList.data = result.data.content.data;

            } catch (error) {
                console.log('error ', error)
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 5000 });
            } finally {
                this.dataList.loading = false;
            }

        },

        formatCpfCnpj(value) {
            return value.length == 14 ? cnpj.format(value) : cpf.format(value);
        },

        viewItem(item) {
            this.$router.push(`relatorio/${item.report_data_id}`);
        },
    },
};
</script>